export default __webpack_public_path__ + "static/csOdMlOo-b580444d4cdd579fe209ca5c4dd5893f.svg";